export default __webpack_public_path__ + "static/media/Invitación_Desfile_de_Comparsas_Avenida_Primavera_y_Desfile_de_Silleteros.ca876f33.pdf";